import axios from '../axios';

// 核对数据
export const getOrderList = data => {
  return axios({
    url: '/CompanySalaryOrder/findCompanySalaryOrderList',
    method: 'post',
    data
  })
};

// 删除操作
export const del = data => {
  return axios({
    headers: { 'Content-Type': 'multipart/form-data'},
    url: '/CompanySalaryOrder/deleteSalaryOrderInfo',
    method: 'post',
    data
  })
};

// 打印接口
export const print = params => {
    return axios({
        url: '/salaryOrderUploadExcel/printSalaryBuildData',
        method: 'get',
        params
    })
};


// WEBPACK FOOTER //
// ./src/http/moudules/send.js